module.exports = __webpack_public_path__ + "img/cjchengji.36bf7f3c.jpg";